import { FormControl, Grid, Typography } from "@mui/material";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { useQuery, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import AutoCompleteSingleSearch from "../../components/autocomplete/AutoCompleteSingleSearch";
import BoxwithTitleAndInfo from "../../components/box/boxwithTitleAndInfo/boxwithTitleAndInfo";
import CustomisedButton from "../../components/button/button";
import DivisionCmp from "../../components/cards/DivisionCmp";
import DatePickerComponents from "../../components/datePicker/DatePickerComponents";
import ModalWithOtp from "../../components/modals/ModalWithOtp";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import { SALE_ITEM } from "../../config/cacheKey";
import { branchResponse } from "../../models/branch.model";
import { verifyCustomerInformationResponse } from "../../models/customer.model";
import { ISaleItemRequest } from "../../models/sale.model";
import { GetBranchBySupplier } from "../../services/branch.service";

const CustomerInfo = forwardRef(
  (
    {
      setDataVerifyCustomer,
      dataVerifyCustomer,
    }: {
      setDataVerifyCustomer: Function;
      dataVerifyCustomer: verifyCustomerInformationResponse;
    },
    ref: any
  ) => {
    const [birthDate, setBirthDate] = useState<Date | undefined>(undefined);
    const [nationalCode, setNationalCode] = useState<string>();
    const [branchStoreAddress, setBranchStoreAddress] = useState<string>();
    const [branchStoreId, setBranchStoreId] = useState<number>();
    const [branchStore, setBranchStore] = useState<branchResponse[]>();
    const [selectedCount, setSelectedPart] = useState();
    const [branchStoreValue, setBranchStoreValue] = useState<any>();
    const historyBranchId = useHistory<{
      branchId: number;
    }>();
    const yupMax = 10;
    const yupMobileMax = 11;

    const nationalCodeHandleKeyDown = (event: any) => {
      var key = event.keyCode ? event.keyCode : event.which;
      const allowedKeys = [8, 46, 37, 38, 39, 40]; // Backspace, Delete, Arrow Keys

      // بررسی کلیدهای مجاز
      if (!/[0-9]/.test(event.key) && !allowedKeys.includes(key)) {
        event.preventDefault();
      }

      // بررسی محدودیت طول
      if (
        event.target.value.length >= yupMax &&
        !allowedKeys.includes(key) &&
        selectedCount === 0
      ) {
        event.preventDefault();
      }
    };
    function changeValueNationalCode(e: any) {
      setNationalCode(e.currentTarget.value);
    }
    const mobileNumberCodeHandleKeyDown = (event: any) => {
      var key = event.keyCode ? event.keyCode : event.which;
      if (!/[0-9]/.test(event.key) && key !== 8 && key !== 46) {
        event.preventDefault();
      }
      if (
        event.target.value.length >= yupMobileMax &&
        key !== 8 &&
        key !== 46 &&
        selectedCount === 0
      ) {
        event.preventDefault();
      }
    };

    const currentSelection = (e: any) => {
      setSelectedPart(
        e.target.value.substring(e.target.selectionStart, e.target.selectionEnd)
          .length
      );
    };

    useQuery<branchResponse[]>("GetBranchBySupplier", GetBranchBySupplier, {
      onSuccess(data) {
        setBranchStore(data!);
      },
    });

    useImperativeHandle(ref, () => ({
      resetFields: () => {
        setNationalCode("");
        setBirthDate(undefined);
      },
    }));
    useEffect(() => {
      const branchId =
        historyBranchId.location.state !== undefined
          ? historyBranchId.location.state.branchId
          : null;
      if (branchId && branchStore) {
        const foundBranch = branchStore?.find(
          (branch) => branch.id === branchId
        );
        if (foundBranch) {
          setBranchStoreId(foundBranch.id);
          setBranchStoreAddress(foundBranch.address);
        }
      }
    }, [branchStore, historyBranchId]);
    const handleSelectedBranchStore = (e: any, value: any) => {
      // e.preventDefault();
      setBranchStoreAddress(
        branchStore?.find((item) => item.id === e)?.address
      );
      setBranchStoreId(e);
      setBranchStoreValue(value);
      // setBranchStoreId(e.target.value);
    };

    function changeBirthDate(e: any) {
      setBirthDate(e);
    }
    const handleRetryInquiry = () => {
      setNationalCode("");
      setBirthDate(undefined);
      setDataVerifyCustomer(undefined);
    };
    return (
      <div style={{ paddingRight: "36px", paddingTop: "15px" }}>
        <Grid container flexDirection={{ xs: "column", md: "row" }} gap={2}>
          <Grid
            md={3}
            style={{ paddingLeft: "20px" }}
            borderLeft={{ xs: "unset", md: "2px solid #CFD8DC" }}
          >
            <Typography className="mbottom30">
              اطلاعات متقاضی را وارد کنید:
            </Typography>
            <Grid container gap={2}>
              <Grid item width={"100%"}>
                <MaterialTextFieldComponent
                  disable={!!dataVerifyCustomer}
                  value={nationalCode}
                  placeHolder={"کد ملی "}
                  label={"کد ملی "}
                  required={true}
                  name="nationalCode"
                  id="nationalCode"
                  onChange={(e: any) => setNationalCode(e.currentTarget.value)}
                  onKeyDown={nationalCodeHandleKeyDown}
                  onSelect={currentSelection}
                />
              </Grid>
              <Grid item width={"100%"}>
                <FormControl fullWidth className="shadowDatepicker">
                  <DatePickerComponents
                    disable={!!dataVerifyCustomer}
                    value={birthDate! ? birthDate : undefined}
                    label={"تاریخ تولد *"}
                    // onChange={(newValue: any) => setBirthDate(newValue)}
                    onChange={changeBirthDate}
                    range={false}
                    fixMainPosition={true}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            md={6}
            paddingRight={{ xs: "unset", md: "20px" }}
            paddingLeft={{ xs: "20px", md: "unset" }}
          >
            <Typography className="mbottom30">
              شعبه و فروشگاه پذیرنده را انتخاب کنید:
            </Typography>
            <Grid container md={6}>
              <Grid item width={"100%"}>
                <AutoCompleteSingleSearch
                  disable={!!dataVerifyCustomer}
                  label={" شعبه و فروشگاه *"}
                  name={`branchStoreId`}
                  id={`branchStoreId`}
                  value={branchStoreId ? branchStoreId : ""}
                  options={branchStore}
                  onChange={handleSelectedBranchStore}
                  responseValue={branchStoreValue}
                />
              </Grid>
            </Grid>
            <Grid container md={12}>
              <Grid item width={"100%"}>
                {branchStoreId && (
                  <Typography className="mTop20" style={{ color: "#34495E" }}>
                    <span style={{ color: "#2962FF" }}> نشانی :</span>
                    &nbsp;{branchStoreAddress}
                  </Typography>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid xs={12} container>
          <Grid md={8}></Grid>
          <Grid
            xs={12}
            md={2}
            className="mTop30 "
            style={{
              paddingLeft: "20px",
            }}
          >
            <ModalWithOtp
              nationalCode={nationalCode!}
              birthDate={birthDate!}
              branchId={branchStoreId!}
              disable={
                !nationalCode ||
                !birthDate ||
                !branchStoreId ||
                !!dataVerifyCustomer
              }
              setDataVerifyCustomer={setDataVerifyCustomer}
            />
          </Grid>
          <Grid
            xs={12}
            md={2}
            className="mTop30 "
            style={{
              paddingLeft: "20px",
            }}
          >
            <CustomisedButton
              title={`  استعلام مجدد  `}
              disable={!dataVerifyCustomer}
              onClick={handleRetryInquiry}
              type="submit"
            />
          </Grid>
        </Grid>
      </div>
    );
  }
);

export function CustomerInquiry() {
  const [dataVerifyCustomer, setDataVerifyCustomer] = useState<
    verifyCustomerInformationResponse
  >();
  const history = useHistory<{
    saleKey: string;
    branchId: number;
    customerPersonId: number;
  }>();

  const customerInfoRef = useRef<any>();
  const queryClient = useQueryClient();
  const handleContinue = () => {
    const request = {} as ISaleItemRequest;
    request.saleKey = dataVerifyCustomer?.saleKey!;
    request.branchId = dataVerifyCustomer?.branchId!;
    request.customerPersonId = dataVerifyCustomer?.customerPersonId!;
    localStorage.setItem(SALE_ITEM, JSON.stringify(request));
    if (
      dataVerifyCustomer?.amount! >= 0 &&
      dataVerifyCustomer?.saleKey !== undefined &&
      dataVerifyCustomer?.branchId !== undefined &&
      dataVerifyCustomer?.customerPersonId !== undefined
    ) {
      history.push(`/sale/ProformaInvoice`);
    }
  };

  const marginTop = dataVerifyCustomer ? "calc(34vh - 40px)" : "34vh";
  return (
    <div className="devForDevisionCard">
      <div className="mTop10">
        <DivisionCmp
          title="استعلام اعتبار متقاضی و انتخاب شعبه فروشگاه"
          child={
            <CustomerInfo
              ref={customerInfoRef}
              setDataVerifyCustomer={setDataVerifyCustomer}
              dataVerifyCustomer={dataVerifyCustomer!}
            />
          }
        />
      </div>
      {dataVerifyCustomer && (
        <div className="mTop40">
          <DivisionCmp
            title="نتیجه استعلام"
            child={
              <div className="px-8">
                <BoxwithTitleAndInfo dataVerifyCustomer={dataVerifyCustomer!} />
              </div>
            }
          />
        </div>
      )}
      <Grid
        container
        sx={{
          position: "fixed",
          bottom: "10px",
          left: { xs: "unset", md: "10px" },
        }}
      >
        <Grid item xs={0} sm={8} md={7}></Grid>
        <Grid
          item
          xs={12}
          sm={4}
          md={5}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            padding: "5px",
          }}
          container
        >
          <Grid
            xs={12}
            md={3}
            style={{
              paddingLeft: "20px",
            }}
          >
            <CustomisedButton
              title={` تایید و ادامه  `}
              disable={dataVerifyCustomer?.amount! === 0 || !dataVerifyCustomer}
              onClick={handleContinue}
              type="submit"
            />
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
